module.exports = __webpack_public_path__ + "ba28aed47d8cede9ec2625cb08a03138.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/wellbeing/wellbeing-cover-summer-2013-1.jpg
 ** module id = 471
 ** module chunks = 0
 **/